module.exports = XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./~/xhr2/lib/browser.js
// module id = 962
// module chunks = 0